const validateEmail = (email: string) => {
  const re =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@(([^<>()[\]\\.,;:\s@"]+\.)+[^<>()[\]\\.,;:\s@"]{2,})$/i;
  return re.test(String(email).toLowerCase());
};

// Only digits/spaces/dashes/parens with an optional leading +, and — unlike the
// looser checkout rule — at least 10 *actual* digits, so "----------" is rejected.
const validatePhone = (phone: string) => {
  const value = String(phone).trim();
  return (
    /^[+]?[(]?[\d\s\-()]+$/.test(value) &&
    (value.match(/\d/g)?.length ?? 0) >= 10
  );
};

// Minimum password strength: at least 8 characters, including a letter and a
// number (matches the server rule in spec NL-9561).
const validatePassword = (password: string) => {
  return /^(?=.*[A-Za-z])(?=.*\d).{8,}$/.test(password);
};

export {
  validateEmail,
  validatePhone,
  validatePassword
};